<script lang="ts">
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, passwordPolicyViolations } from '../../../shared/password-policy'

// MYS-7479: the Keycloak realm password policy, checked in every form that sets a new password.
// text.passwordPolicy<Violation> per rule, e.g. passwordPolicyTooShort for 'tooShort'
export default {
	methods: {
		// vuelidate rule; required is checked separately, so an empty field is not reported twice
		passwordPolicyRule(email?: string) {
			return (value: string) => !value || passwordPolicyViolations(value, email).length === 0
		},
		passwordPolicyMessages(password: string, email?: string): string[] {
			return password ? this.passwordViolationMessages(passwordPolicyViolations(password, email)) : []
		},
		// api1 answers a rejected password with { error: 'passwordPolicy', violations },
		// api2 RMI with PasswordPolicyRmiError (code PASSWORD_POLICY, violations)
		passwordPolicyApiMessages(error: any): string[] {
			const rejected = error?.error === 'passwordPolicy' || error?.code === 'PASSWORD_POLICY'
			return rejected ? this.passwordViolationMessages(error.violations ?? []) : []
		},
		passwordViolationMessages(violations: string[]): string[] {
			return violations.map(violation => this.$t('text.passwordPolicy' + violation.charAt(0).toUpperCase() + violation.slice(1), { min: PASSWORD_MIN_LENGTH, max: PASSWORD_MAX_LENGTH }))
		},
		passwordPolicyHint(): string {
			return this.$t('text.passwordPolicyHint', { min: PASSWORD_MIN_LENGTH, max: PASSWORD_MAX_LENGTH })
		},
	},
}
</script>
